export default __webpack_public_path__ + "static/media/soil.3dcd7732.jpeg";